<script>
  import { debounce } from 'lodash';
  import { searchAuthors, sendCopy } from '@authoringPlatform/../api/authors';
  export default {
    name: 'SendCopy',

    data() {
      return {
        results: [],
        selectedAuthor: null,
        showList: true,
        authorName: '',
        showSuccess: false,
        showError: false,
      };
    },

    props: {
      versionKey: {
        type: [Number, String],
      },
      versionName: {
        type: String,
      },
    },
    watch: {
      versionKey: {
        immediate: true,
        handler(oldKey, newKey) {
          if (oldKey !== newKey) {
            this.showSuccess = false;
            this.showError = false;
          }
        },
      },
    },

    methods: {
      debouncedHandleInput: debounce(function (query) {
        this.handleInput(query);
      }, 1000),

      async handleInput(query) {
        const authorList = await searchAuthors(query);
        this.results = authorList;
        this.showList = true;
      },

      hideModal() {
        $('#send-copy-modal').modal('hide');
      },

      selectAuthor({ actorKey, firstName, lastName }) {
        this.selectedAuthor = actorKey;
        this.showList = false;
        this.authorName = lastName + ', ' + firstName;
      },

      async sendCopy() {
        try {
          await sendCopy({
            versionKey: this.versionKey,
            actorKey: this.selectedAuthor,
          });
          this.showSuccess = true;
        } catch {
          this.showError = true;
        } finally {
          this.authorName = '';
        }
      },
    },
  };
</script>
<template>
  <modal :show-footer="!showSuccess">
    <h3 slot="title" class="m-0">Send Copy - {{ versionName }}</h3>
    <template slot="body">
      <template v-if="showSuccess">
        <div class="text-center p-10">
          <strong class="text-success"> Success! A copy of your version was shared. </strong>
        </div>
      </template>
      <template v-else-if="showError">
        <div class="text-center">
          <strong class="text-danger"> Error! A copy of your version could not be shared. </strong>
        </div>
      </template>
      <template v-else>
        <div class="form-horizontal">
          <div class="form-group">
            <label class="col-sm-2 control-label" for="author-name">Send to</label>
            <div class="col-sm-10">
              <input
                ref="authorName"
                v-model="authorName"
                id="author-name"
                @input="debouncedHandleInput($event.target.value)"
                type="text"
                class="form-control"
              />
              <div v-show="showList">
                <ul style="position: absolute" class="list-group">
                  <li
                    class="list-group-item"
                    style="cursor: pointer"
                    v-for="author in results"
                    @click="selectAuthor(author)"
                    :key="author.actorKey"
                  >
                    {{ author.lastName }}, {{ author.firstName }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </template>
    </template>
    <div slot="footer">
      <button @click="hideModal" class="btn btn-default pull-left">Cancel</button>
      <button @click="sendCopy" class="btn btn-success">Send</button>
    </div>
  </modal>
</template>
